import React from "react";

import { CloseOutlined } from "@ant-design/icons";
import {
  Button, Divider, Modal, Space, Tag, Typography,
} from "antd";

import { ReactComponent as StackSolidIcon } from "../../../../../assets/images/icons/stack-solid.svg";

import "./PanelRelatedTestsModal.css";

export default function PanelRelatedTestsModal({
  open,
  panelName,
  selectedMemberNames = [],
  otherMemberNames = [],
  totalMemberCount = 0,
  loading = false,
  onRemoveSelected,
  onAddOther,
  onAddFullPanel,
  onAddIndividual,
  onClose,
}) {
  if (!open) return null;

  const additionalCount = Math.max(totalMemberCount - selectedMemberNames.length, 0);
  const [firstMember, secondMember] = selectedMemberNames;
  const selectedSummary = selectedMemberNames.length >= 2
    ? `${firstMember} and ${secondMember}`
    : (firstMember || "");
  const hasOtherMembers = otherMemberNames.length > 0;

  return (
    <Modal
      open
      centered
      width={520}
      closable={!loading}
      maskClosable={!loading}
      destroyOnHidden
      wrapClassName="PanelRelatedTestsModal"
      className="PanelRelatedTestsModal"
      closeIcon={<CloseOutlined />}
      onCancel={loading ? undefined : onClose}
      title={`Related ${panelName} tests Detected`}
      footer={(
        <div className="PanelRelatedTestsModal__footerActions">
          <Button
            type="default"
            htmlType="button"
            disabled={loading}
            icon={<StackSolidIcon className="PanelRelatedTestsModal__FullPanelIcon" aria-hidden />}
            onClick={onAddFullPanel}
          >
            {`Add full ${panelName}`}
          </Button>
          <Button
            type="primary"
            htmlType="button"
            loading={loading}
            onClick={onAddIndividual}
          >
            Add as individual Test
          </Button>
        </div>
      )}
    >
      <div className="PanelRelatedTestsModal__bodyInner">
        <div className="PanelRelatedTestsModal__top">
          <Space direction="vertical" size={8} className="PanelRelatedTestsModal__textBlock">
            <Typography.Paragraph className="PanelRelatedTestsModal__message">
              {selectedSummary}
              {" are part of the "}
              {panelName}
              {" panel with +"}
              {additionalCount}
              {" additional tests."}
            </Typography.Paragraph>
            <Typography.Text className="PanelRelatedTestsModal__warning">
              Note: Individual tests use separate specifications.
            </Typography.Text>
          </Space>

          <Space size={8} wrap className="PanelRelatedTestsModal__chipRow">
            {selectedMemberNames.map((name) => (
              <Tag
                key={name}
                closable={!loading}
                className="PanelRelatedTestsModal__Tag PanelRelatedTestsModal__Tag--selected"
                onClose={(e) => {
                  e.preventDefault();
                  onRemoveSelected(name);
                }}
              >
                {name}
              </Tag>
            ))}
          </Space>
        </div>

        {hasOtherMembers && (
          <>
            <Divider className="PanelRelatedTestsModal__divider" />
            <Space direction="vertical" size={8} className="PanelRelatedTestsModal__otherSection">
              <Typography.Text className="PanelRelatedTestsModal__otherLabel">
                Other individual tests in
                {" "}
                {panelName}
                {" Panel"}
              </Typography.Text>
              <Space size={8} wrap className="PanelRelatedTestsModal__chipRow">
                {otherMemberNames.map((name) => (
                  <Tag
                    key={name}
                    className="PanelRelatedTestsModal__Tag PanelRelatedTestsModal__Tag--other"
                    onClick={loading ? undefined : () => onAddOther(name)}
                  >
                    {name}
                  </Tag>
                ))}
              </Space>
            </Space>
          </>
        )}
      </div>
    </Modal>
  );
}
